import dayjs from 'dayjs';
import { defineStore } from 'pinia';

export interface RecommendRankState {
  rank: number[];
  createdAt: number | null;
}

interface RankItem {
  id: number;
  [key: string]: any;
}

interface LowRankItem extends RankItem {
  _priority: number;
}

export const useRecommendRankStore = defineStore('recommend-rank', {
  state: (): RecommendRankState => ({
    rank: [],
    createdAt: null,
  }),
  getters: {
    getRankedList(state) {
      return (list: RankItem[]) => {
        const high: RankItem[] = [];
        const low: LowRankItem[] = [];

        list.forEach((item) => {
          const index = state.rank.findIndex((v) => v === item.id);

          // 存在时说明优先级比较低
          if (index > -1) {
            low.push({
              ...item,
              _priority: index,
            });
            // 不存在则说明优先级比较高
          } else {
            high.push(item);
          }
        });

        return high.concat(low.sort((a, b) => a._priority - b._priority));
      };
    },
  },
  actions: {
    saveRecommendRank(id: number) {
      const index = this.rank.findIndex((v) => v === id);

      if (index > -1) {
        const current = this.rank.splice(index, 1);
        this.rank = this.rank.concat(Array.isArray(current) ? current : [current]);
      } else {
        this.rank.push(id);
      }

      if (this.createdAt == null) {
        this.createdAt = dayjs().add(1, 'day').valueOf();
      }
    },
    clearRecommendRank() {
      this.rank = [];
      this.createdAt = null;
    },
  },
  persist: true,
});
